(function () {
  // Map: Shopify option name -> Infinite Options property name
  const optionNameMap = {
    'Would you like to add an insert?': 'Inserts'
    // add more entries here if other fields have mismatched labels
  };

  function syncInfiniteOption(nativeSelect) {
    const value = nativeSelect.value;
    let optionName = nativeSelect.name.match(/\[(.+)\]/)?.[1];
    if (!optionName) return;

    optionName = optionNameMap[optionName] || optionName;

    const infiniteOption = document.querySelector(`select[name="properties[${optionName}]"]`);
    if (!infiniteOption) return;

    infiniteOption.value = value;
    infiniteOption.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncAll() {
    document.querySelectorAll('select.variant-option__select').forEach(function (select) {
      syncInfiniteOption(select);
    });
  }

  function attachChangeListeners() {
    document.querySelectorAll('select.variant-option__select').forEach(function (select) {
      select.addEventListener('change', function () {
        syncInfiniteOption(select);
      });
    });
  }

  function waitForInfiniteOptions(callback) {
    if (document.querySelector('select[name^="properties["]')) {
      callback();
      return;
    }
    const observer = new MutationObserver(function () {
      if (document.querySelector('select[name^="properties["]')) {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 5000);
  }

  function init() {
    attachChangeListeners();
    waitForInfiniteOptions(syncAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      setTimeout(init, 500);
    }
  });
})();